import { Alert as ChakraAlert } from '@chakra-ui/react';
import * as React from 'react';

export interface AlertProps extends Omit<ChakraAlert.RootProps, 'title'> {
	endElement?:   React.ReactNode
	icon?:         React.ReactElement
	startElement?: React.ReactNode
	title?:        React.ReactNode
}

export const Alert = React.forwardRef<HTMLDivElement, AlertProps>(function Alert(props, ref) {
	const {
		children, endElement, icon, startElement, title, ...rest
	} = props;

	return (
		<ChakraAlert.Root ref={ref} {...rest}>
			{startElement || (
				<ChakraAlert.Indicator>
					{icon}
				</ChakraAlert.Indicator>
			)}
			{children
				? (
						<ChakraAlert.Content>
							<ChakraAlert.Title>
								{title}
							</ChakraAlert.Title>
							<ChakraAlert.Description>
								{children}
							</ChakraAlert.Description>
						</ChakraAlert.Content>
					)
				: (
						<ChakraAlert.Title flex="1">
							{title}
						</ChakraAlert.Title>
					)}
			{endElement}
		</ChakraAlert.Root>
	);
});
